import React from "react";
import { Message } from "lib/components/index";

import { st, FormControl, StockAvailability, CouponCodeDecorator } from "lib/index";

export default class CouponCodeFormSection extends React.PureComponent {
  handlePropChange(prop, value) {
    const { coupon_code, onChange } = this.props;
    const nextCc = new CouponCodeDecorator({
      ...coupon_code,
      [prop]: value,
    });
    onChange(nextCc);
  }

  render() {
    const { readOnlyAccess, coupon_code, errors, name, onBlur, onRemove, focus = false } = this.props;

    return (
      <div>
        <div className="fields inline u-positionRelative">
          {!!errors[name] && <FormMessage error={errors[name]} />}

          <FormControl.InputFormGroup
            {...FormControl.addProps(`${name}.name`, { errors })}
            value={coupon_code.name}
            onBlur={onBlur}
            onChange={this.handlePropChange.bind(this, "name")}
            placeholder={
              coupon_code._new
                ? I18n.t("papp.products.EditProductView.StepPricelist.new_coupon_code_name")
                : I18n.t("papp.products.EditProductView.StepPricelist.coupon_code_name")
            }
            required
            readOnly={readOnlyAccess}
            autoFocus={focus}
          />

          <FormControl.NumberLimitFormGroup
            {...FormControl.addProps(`${name}.total_stock_limit`, { errors })}
            value={coupon_code.total_stock_limit}
            onBlur={onBlur}
            onChange={this.handlePropChange.bind(this, "total_stock_limit")}
            readOnly={readOnlyAccess}
            min={1}
            label={
              <span>
                {I18n.humanAttributeName("coupon_code", "total_stock_limit")} (
                <StockAvailability
                  used={coupon_code.total_stock_used}
                  limit={coupon_code.total_stock_limit}
                  type="item"
                />
                )
              </span>
            }
          />

          {!readOnlyAccess && !coupon_code._new && <FormControl.DeleteRowButton onClick={onRemove} />}
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/modules/products/EditProductView/StepBookingSettings/CouponCodeFormSection.jsx